document.addEventListener("DOMContentLoaded", () => {
  // Lấy tất cả các nút mở modal
  const modalTriggers = document.querySelectorAll(".js-modal");
  const closeButtons = document.querySelectorAll(".js-close-modal");

  // Mở modal
  modalTriggers.forEach(trigger => {
    trigger.addEventListener("click", () => {
      const modalId = trigger.getAttribute("data-modal-id");
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.add("show");
      }
    });
  });

  // Đóng modal
  closeButtons.forEach(button => {
    button.addEventListener("click", () => {
      const modal = button.closest(".modal");
      if (modal) {
        modal.classList.remove("show");
      }
    });
  });

  // Đóng modal khi nhấn bên ngoài modal
  document.querySelectorAll(".modal").forEach(modal => {
    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        modal.classList.remove("show");
      }
    });
  });
});

export function onCloseModal() {
  document.querySelectorAll(".modal").forEach(modal => {
    modal.classList.remove("show");
  });
}
